import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import SwatchGroup from '@salesforce/retail-react-app/app/components/swatch-group';

import {
  CardAttributeValue,
} from '@amblique/king-living/app/components/product-view/variation-attributes-simple/card-attribute-value';
import {
  DefaultAttributeValue,
} from '@amblique/king-living/app/components/product-view/variation-attributes-simple/default-attribute-value';
import {
  ListItemAttributeValue,
} from '@amblique/king-living/app/components/product-view/variation-attributes-simple/list-item-attribute-value';

/**
 * Variation Attributes Simple
 * Renders variation attributes for simple products.
 *
 * @param {object} props
 * @param {Product} props.product
 * @param {boolean} props.isProductPartOfSet
 * @param {boolean} props.isProductPartOfBundle
 * @returns {React.ReactNode}
 */
export const VariationAttributesSimple = ({
  variationAttributes,
}) => {
  const intl = useIntl();
  const variationAttributeValues = {
    color: CardAttributeValue,
    size: ListItemAttributeValue,
  };

  return variationAttributes.map((attribute) => {
    const {id, name, selectedValue, values} = attribute;
    const VariationAttributeValue = variationAttributeValues[id] || DefaultAttributeValue;

    return (
      <SwatchGroup
        key={id}
        displayName={selectedValue?.name || ''}
        value={selectedValue?.value}
        variant={id === 'color' ? 'card' : 'list-item'}
        label={intl.formatMessage({
          defaultMessage: '{variantType}',
          id: 'product_view.label.variant_type',
        }, {variantType: name})}
      >
        {values.map((attributeValue, index) => (
          <VariationAttributeValue
            key={attributeValue.value}
            attribute={attribute}
            attributeValue={attributeValue}
            index={index}

            // pwa-kit backward compatibility
            value={attributeValue.value}
          />
        ))}
      </SwatchGroup>
    );
  });
};

VariationAttributesSimple.displayName = 'VariationAttributesSimple';

VariationAttributesSimple.propTypes = {
  variationAttributes: PropTypes.array,
};
